'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _WebAPI = require('../WebAPI');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore
 * @param {Object} fields
 * @param {string} alias
 * @param {*} defaultValue
 * @returns {*}
 */
var findFieldValue = function findFieldValue(_ref, alias, defaultValue) {
  var fields = _ref.data.fields;

  if (!fields || (typeof fields === 'undefined' ? 'undefined' : (0, _typeof3.default)(fields)) !== 'object') {
    return defaultValue;
  }

  var foundFields = (0, _keys2.default)(fields).map(function (key) {
    return fields[key];
  }).filter(function (field) {
    if (field && field.aliases instanceof Array) {
      return -1 !== field.aliases.indexOf(alias);
    }
    return false;
  });

  if (1 === foundFields.length) {
    var field = foundFields.pop();
    return field.value;
  }

  return defaultValue;
};

/**
 * An API client that enables reading or writing the values of custom fields
 *
 * @class
 */

var CustomFieldsClient = function () {
  /**
   * @param {AppEventEmitter} outgoingDispatcher the outgoing events dispatcher
   * @param {string} instanceId this application's instance id
   * @param {string} endpoint Deskpro API endpoint for the custom fields resource
   */
  function CustomFieldsClient(_ref2) {
    var outgoingDispatcher = _ref2.outgoingDispatcher,
        instanceId = _ref2.instanceId,
        endpoint = _ref2.endpoint;
    (0, _classCallCheck3.default)(this, CustomFieldsClient);

    this.props = { outgoingDispatcher: outgoingDispatcher, instanceId: instanceId, endpoint: endpoint };
  }

  /**
   * Set the value of a field
   *
   * @method
   *
   * @param {string} id
   * @param {String|Number|Array<String|Number>} value
   *
   * @return {Promise.<DeskproAPIResponse, Error>}
   */


  (0, _createClass3.default)(CustomFieldsClient, [{
    key: 'setField',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(id, value) {
        var _props, outgoingDispatcher, url, body, init;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, outgoingDispatcher = _props.outgoingDispatcher, url = _props.endpoint;
                body = {
                  fields: (0, _defineProperty3.default)({}, id, value)
                };
                init = {
                  method: 'PUT',
                  headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                  },
                  body: (0, _stringify2.default)(body)
                };
                return _context.abrupt('return', outgoingDispatcher.emitAsync(_WebAPI.WebAPIEvents.EVENT_WEBAPI_REQUEST_FETCH, { url: url, init: init }));

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setField(_x, _x2) {
        return _ref3.apply(this, arguments);
      }

      return setField;
    }()

    /**
     * Retrieves the value of a field
     *
     * @param {String} id
     * @param {*} defaultValue
     * @return {Promise.<String|null|Array<String|null>, Error>}
     */

  }, {
    key: 'getField',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(id) {
        var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        var _props2, outgoingDispatcher, url, init;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _props2 = this.props, outgoingDispatcher = _props2.outgoingDispatcher, url = _props2.endpoint;
                init = {
                  method: 'GET',
                  headers: { 'Accept': 'application/json' }
                };
                return _context2.abrupt('return', outgoingDispatcher.emitAsync(_WebAPI.WebAPIEvents.EVENT_WEBAPI_REQUEST_FETCH, { url: url, init: init }).then(function (_ref5) {
                  var status = _ref5.status,
                      body = _ref5.body;
                  return status === 'success' ? findFieldValue(body, id, defaultValue) : defaultValue;
                }));

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getField(_x3) {
        return _ref4.apply(this, arguments);
      }

      return getField;
    }()

    /**
     * Sets the value of a field which is specifically linked to this application. Such fields include those created
     * when the application was installed
     *
     * @param {string} alias
     * @param {*} value
     * @return {Promise.<DeskproAPIResponse, Error>}
     */

  }, {
    key: 'setAppField',
    value: function () {
      var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(alias, value) {
        var fieldId;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                fieldId = 'app:' + this.props.instanceId + ':' + alias;
                return _context3.abrupt('return', this.setField(fieldId, value));

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function setAppField(_x5, _x6) {
        return _ref6.apply(this, arguments);
      }

      return setAppField;
    }()

    /**
     * Returns the value of a field which is referenced by this application. Such fields include those created
     * when the application was installed
     *
     * @param {string} alias
     * @param {*} defaultValue
     *
     * @return {Promise.<String|null|Array<String|null>, Error>}
     */

  }, {
    key: 'getAppField',
    value: function () {
      var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(alias) {
        var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var fieldId;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                fieldId = 'app:' + this.props.instanceId + ':' + alias;
                return _context4.abrupt('return', this.getField(fieldId, defaultValue));

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getAppField(_x7) {
        return _ref7.apply(this, arguments);
      }

      return getAppField;
    }()
  }]);
  return CustomFieldsClient;
}();

exports.default = CustomFieldsClient;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/CustomFields/CustomFieldsClient.js
// module id = 321
// module chunks = 0